import React, { useState } from "react";
import useFetchCompany from "./useFetchCompany";
import { OverlayLoader, Ptag } from "components/core";
import HeaderView from "./HeaderView";
import CashDeposit from "./CashDeposit";
import { OverviewWrapper } from "./styles";
import Footer from "components/v1/Footer";
import useFetchCd from "hooks/useFetchCd";
import CoverageDetails from "./CoverageDetails";
import http from "services/httpService";
import ReminderConfirmationModal from "./ReminderConfirmationModal";

function Overview() {
  const { loading, company } = useFetchCompany();
  const { loading: cdLoading, cdDetail } = useFetchCd({ presist: true });
  const [showDialog, setShowDialog] = useState(false);

  const sendReminder = async () => {
    const { data } = await http.post("/business/send_reminder_mail_to_employees/");
  };

  if (loading || cdLoading) {
    return <OverlayLoader />;
  }

  return (
    <OverviewWrapper>
      <HeaderView
        active_employee_count={company.active_employee_count}
        logged_in_employee_count={company.logged_in_employee_count}
        sendReminder={() => setShowDialog(true)}
      />
      <CashDeposit cdDetail={cdDetail} />
      <CoverageDetails products={company.product_details} showClaims={company?.show_claim_summary} />
      <Footer />
      <ReminderConfirmationModal
        open={showDialog}
        sendReminder={sendReminder}
        handleClose={() => setShowDialog(false)}
      />
    </OverviewWrapper>
  );
}

export default Overview;
